module.exports = __webpack_public_path__ + "static/media/cover_footmassage.14cf11c6.jpg";